import React from "react";
import ic2 from "../images/icon-couter-2.png";
import ic3 from "../images/icon-couter-3.png";
import ic4 from "../images/icon-couter-4.png";
import "../style/Reviews.css";
import hc from "../images/healthcare.jpeg";

const Reviews = () => {
  return (
    <section className="reviews" id="reviews">
      <h1 className="heading"> Our Clients </h1>
      <div className="stats-container">
        <div className="stat-card">
          <div className="stat-icon">
            <img src={ic2} alt="icon-couter-1" />
          </div>
          <div className="stat-number">10K</div>
          <div className="stat-description">Happy Customers</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">
            <img src={ic3} alt="icon-couter-2" />
          </div>
          <div className="stat-number">100%</div>
          <div className="stat-description">Satisfaction</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">
            <img src={ic4} alt="icon-couter-3" />
          </div>
          <div className="stat-number">25+</div>
          <div className="stat-description">Years of experience</div>
        </div>
      </div>
      <div className="healthcare-container">
        <div className="healthcare-image">
          <img src={hc} alt="Healthcare" />
        </div>
        <div className="healthcare-content">
          <h1>Orthodontist-Guided Precision</h1>
          <p>
            Lamaan combines cutting-edge 3D technology with high-quality
            invisible braces to provide a seamless teeth-straightening
            experience. Our licensed orthodontists tailor each treatment plan to
            align your smile comfortably and effectively, with results in an
            average of 8 months.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
